const fixedHolidays = [
    ['01-01', 'Capodanno'], ['01-06', 'Epifania'], ['04-25', 'Liberazione'],
    ['05-01', 'Festa del lavoro'], ['06-02', 'Festa della Repubblica'],
    ['12-08', 'Immacolata'], ['12-24', 'Vigilia di Natale'], ['12-25', 'Natale'],
];

// Gregorian Easter (Meeus/Jones/Butcher). UTC keeps the date independent of DST.
function easterSunday(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    return new Date(Date.UTC(year, month - 1, day));
}

function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const parsed = new Date(value+'T00:00:00Z');
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}

// Bound the work while native date inputs emit intermediate years (0002, 0020...).
const maxHolidayYears = 10;
function holidayRangeTooLong({from, to}) {
    return validDate(from) && validDate(to) && from <= to && Number(to.slice(0, 4)) - Number(from.slice(0, 4)) >= maxHolidayYears;
}

function standardHolidaysForRanges(ranges) {
    const valid = ranges.filter(({from, to}) => validDate(from) && validDate(to) && from <= to && !holidayRangeTooLong({from, to}));
    const years = new Set();
    valid.forEach(({from, to}) => {
        for (let year = Number(from.slice(0, 4)); year <= Number(to.slice(0, 4)); year++) years.add(year);
    });
    const dates = new Map();
    const add = (date, label) => {
        if (!valid.some(range => range.from <= date && date <= range.to)) return;
        dates.set(date, dates.has(date) ? dates.get(date)+' / '+label : label);
    };
    years.forEach(year => {
        fixedHolidays.forEach(([day, label]) => add(String(year).padStart(4, '0')+'-'+day, label));
        const easter = easterSunday(year);
        add(easter.toISOString().slice(0, 10), 'Pasqua');
        easter.setUTCDate(easter.getUTCDate() + 1);
        add(easter.toISOString().slice(0, 10), 'Pasquetta');
    });
    return Array.from(dates, ([date, label]) => ({date, label})).sort((a, b) => a.date.localeCompare(b.date));
}

module.exports = {standardHolidaysForRanges, holidayRangeTooLong};
